<i18n lang="yaml">
en:
  speed: 'Network speed test'
ru:
  speed: 'Скорость сети'
</i18n>

<template>
  <div class="header__container header__container--top">
    <div class="container">
      <div class="header__aside">
        <ul class="header__manage-list">
          <li class="header__manage-item">
            <nuxt-link
              :to="switchLocalePath($i18n.locale === 'ru' ? 'en' : 'ru')"
              class="header__manage-link"
            >
              <planet-icon></planet-icon> {{ $i18n.locale === 'ru' ? 'English' : 'Русский' }}
            </nuxt-link>
          </li>
          <li class="header__manage-item">
            <a
              class="header__manage-link"
              href="https://speedtest.selectel.ru/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <lan-speed-icon></lan-speed-icon>
              {{ $t('speed') }}
            </a>
          </li>
          <li class="header__manage-item">
            <a
              class="header__manage-link header__manage-link-status"
              :class="`header__manage-link-status--${statusPanel}`"
              href="http://status.selectel.info/"
              rel="noopener noreferrer"
              target="_blank"
            >
              {{ statusPanelMessage[$i18n.locale] }}
            </a>
          </li>
        </ul>

        <ul class="header__connect-list">
          <li class="header__connect-item">
            <a
              class="header__connect-link"
              href="mailto:sales@selectel.ru"
              data-gtmid="gtm-selectel-mailto-click"
            >
              sales@selectel.ru
            </a>
          </li>
          <li class="header__connect-item">
            <a
              class="header__connect-link"
              href="https://t.me/SelectelTgbot"
              data-gtmid="gtm-selectel-telegram-click"
            >
              Telegram
            </a>
          </li>
          <li class="header__connect-item">
            <a
              class="header__connect-link"
              href="tel:88005550675"
              data-gtmid="gtm-selectel-call-click"
            >
              <phone-icon></phone-icon>
              <span class="mgo-number">8 800 555 06 75</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import PlanetIcon from '~/assets/icons/header/planet.svg'
import LanSpeedIcon from '~/assets/icons/header/lan-speed.svg'
import PhoneIcon from '~/assets/icons/header/phone.svg'
import {mapGetters} from 'vuex'

export default {
  name: 'HeaderAside',
  components: {
    PlanetIcon,
    LanSpeedIcon,
    PhoneIcon
  },
  computed: {
    ...mapGetters('modules/status-panel', ['statusPanelMessage', 'statusPanel'])
  }
}
</script>

<style lang="scss">
  .header__container {
    &--top {
      @media (max-width: $breakpoint-lg) {
        display: none;
      }
    }
  }

.header__aside {
  display: grid;
  margin-left: calc(((100% - 32px) / 6) + 16px);
  grid-template-columns: 1fr 400px;
  grid-column-gap: 16px;

  a {
    color: inherit;
    transition: color 0.2s;

    svg {
      transition: fill 0.2s;
    }
  }
}

.header__manage-list,
.header__connect-list {
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 8px;
  margin-bottom: 0;
  padding: 4px 0;
  list-style: none;
  font-size: 14px;

  & > * {
    min-width: 0;
  }
}

.header__manage-list {
  justify-content: flex-start;
}

.header__connect-list {
  justify-content: flex-end;
}

.header__manage-link,
.header__connect-link {
  display: inline-flex;
  align-items: center;
  padding: 0 4px;
  border-radius: 2px;
  transition: color, background-color 0.2s;

  &:hover,
  &:focus {
    background-color: rgba(#FFF, 0.15);

    .header--white & {
      color: $secondary;
    }
  }

  svg {
    max-width: 12px;
    max-height: 12px;
    margin-right: 0.25em;
  }
}

.header__manage-link-status {
  padding-left: 15.5px;
  max-width: 100%;

  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  background-image: url('~@/assets/icons/single/status-panel/success.svg?inline');
  background-size: 8px 8px;
  background-repeat: no-repeat;
  background-position: left 4px center;
}

.header__manage-link-status--warn {
  background-image: url('~@/assets/icons/single/status-panel/warn.svg?inline');
}

.header__manage-link-status--error {
  background-image: url('~@/assets/icons/single/status-panel/error.svg?inline');
}

.header__manage-link-status--alert {
  background-image: url('~@/assets/icons/single/status-panel/alert.svg?inline');
}
</style>